import { Box, Modal, Typography, styled, Button } from "@mui/material"
import { ModalCard } from "../UnassignModal/UnassignModal.styles"
import { useQueryClient } from "@tanstack/react-query"
import { showToast } from "../../toastSlice"
import { useAppDispatch } from "../../app/hooks"
import {openInvoices, openLogin} from '../../activeScreenSlice'
import { useGetLoginMode, useRefreshToken} from "../../hooks/Users"
import { useAuth } from '../../components/AuthContext/AuthContext'
import useShowError from "../../hooks/useShowError"

const ModalHeader = styled(Typography)({
  fontWeight: 400,
  fontSize: 24,
  lineHeight: "32px",
  color: "var(--black)",
})

const ModalSubheader = styled(Typography)({
  fontWeight: 400,
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: 0.5,
  color: "var(--black)",
})

export default function InterceptorModal({
  open,
  handleClose,
}: {
  open: boolean
  handleClose: () => void
}) {
  let iapSessionRefreshWindow: null | Window = null
  const queryClient = useQueryClient()
  const dispatch = useAppDispatch()
  const loginMode = useGetLoginMode();
  const showError = useShowError();
  const refreshTokenMutation = useRefreshToken();
  const { setAuthToken } = useAuth();

  const logout = () => {
    showToast("Session timed out.")
    localStorage.removeItem("expiration");
    localStorage.removeItem("ssoEnabled");
    
    setAuthToken("");
    dispatch(openLogin());
    queryClient.cancelQueries();
    queryClient.removeQueries();
  };

  function sessionRefreshClicked() {
    if(loginMode?.data?.name === "standard_authentication" || loginMode?.data?.name === "ldap_authentication"
      || loginMode?.data?.name === "passwordless_authentication" || loginMode?.data?.name === "sso_saml"
    ) {
      //Implement refresh mechanism
      refreshTokenMutation.mutate(undefined, {
        onSuccess(response) {
          setAuthToken(response.access_token);
          localStorage.setItem("expiration", response.token_expiry);
          dispatch(openInvoices());
          handleClose();
        },
        onError() {
          handleClose();
          logout();
          showError("Your session expired, please log in.")
        }
      })
      
    }
    else if (iapSessionRefreshWindow == null) {
      iapSessionRefreshWindow = window.open("/?gcp-iap-mode=DO_SESSION_REFRESH")
      window.setTimeout(() => checkSessionRefresh(10), 500)
    }
    return false
  }


  function checkSessionRefresh(retryCount: number) {
    if (iapSessionRefreshWindow != null && !iapSessionRefreshWindow.closed) {
      fetch("/vite.svg")
        .then(function (response) {
          if (response.status === 401) {
            console.log("Not ready yet, waiting to try again")
            window.setTimeout(() => checkSessionRefresh(retryCount - 1), 500)
          } else {
            queryClient.refetchQueries({ fetchStatus: "fetching" })
            if (iapSessionRefreshWindow !== null)
              iapSessionRefreshWindow.close()
            iapSessionRefreshWindow = null
            handleClose()
          }
        })
        .catch((err) => {
          console.log("Exception found")
          console.log(err)
          if (retryCount === 0) {
            throw err
          } else {
            window.setTimeout(() => checkSessionRefresh(retryCount - 1), 500)
          }
        })
    } else {
      iapSessionRefreshWindow = null
    }
  }

  function onLoginClicked(){
    handleClose();
    logout();
  }

  return (
    <Modal
      open={open}
      aria-labelledby="session-refresh-modal-header"
      aria-describedby="session-refresh-modal-subheader"
    >
      <ModalCard>
        <ModalHeader id="session-refresh-modal-header">
          Refreshing your Arrow connection
        </ModalHeader>

        <ModalSubheader id="session-refresh-modal-subheader">
          Please click below to update your Arrow session
        </ModalSubheader>
        <Box sx={{flexDirection: "row"}}>
          <Button
            variant="contained"
            onClick={sessionRefreshClicked}
          >
            Refresh session
          </Button>
          
          {
          (loginMode?.data?.name === "standard_authentication" || loginMode?.data?.name === "ldap_authentication"
            || loginMode?.data?.name === "passwordless_authentication" || loginMode?.data?.name === "sso_saml") && 
            <Button
              variant="outlined"
              onClick={onLoginClicked}
              sx={{marginLeft: '10px'}}
            >
              Go to Login Page
            </Button>
          }
          
        </Box>
      </ModalCard>
    </Modal>
  )
}
